import axios from 'axios';

// Fallback to deployed backend if REACT_APP_API_URL is not set (helps preview deployments)
const defaultBase = process.env.REACT_APP_API_URL || 'https://tradelink-kseg.onrender.com';
const api = axios.create({
  baseURL: defaultBase,
  timeout: 10000,
});

export default api;
